import { supabase } from "@/integrations/supabase/client";

export type TimeTrackingSource = 
  | 'quick_add_15' 
  | 'quick_add_30' 
  | 'quick_add_60' 
  | 'manual' 
  | 'adjustment';

export type TimeTrackingEntryType = 'time_spent' | 'time_estimated';
export type TaskType = 'foundational' | 'growth' | 'recurring';

interface LogTimeEntryParams {
  brandId: string;
  taskId: string;
  taskType: TaskType;
  entryType: TimeTrackingEntryType;
  minutesAdded: number;
  previousTotal: number;
  newTotal: number;
  source: TimeTrackingSource;
  notes?: string;
}

export const logTimeEntry = async (params: LogTimeEntryParams) => {
  const { data: { user } } = await supabase.auth.getUser();
  
  const { error } = await supabase
    .from('os_universal_time_tracking')
    .insert({
      brand_id: params.brandId,
      user_id: user?.id,
      task_id: params.taskId,
      task_type: params.taskType,
      entry_type: params.entryType,
      minutes_added: params.minutesAdded,
      previous_total: params.previousTotal,
      new_total: params.newTotal,
      source: params.source,
      notes: params.notes
    });

  if (error) {
    console.error('Error logging time entry:', error);
  }
  
  return { error };
};

export const useTimeTracking = () => {
  return { logTimeEntry };
};
